// Small helper to remember an ordered list of profile IDs the user is browsing,
// so the profile page can offer prev/next navigation matching the list they
// came from (Community, Friends, Saved, Open-to-meet strip, …).

const KEY = 'bb.profileQueue';

export interface StoredProfileQueue {
  ids: string[];
  ts: number;
}

export function setProfileQueue(ids: string[]) {
  try {
    if (!Array.isArray(ids) || ids.length < 2) {
      sessionStorage.removeItem(KEY);
      return;
    }
    // Dedupe while preserving order.
    const seen = new Set<string>();
    const clean: string[] = [];
    for (const id of ids) {
      if (id && !seen.has(id)) {
        seen.add(id);
        clean.push(id);
      }
    }
    sessionStorage.setItem(KEY, JSON.stringify({ ids: clean, ts: Date.now() }));
  } catch {
    /* ignore */
  }
}

export function getProfileQueueFor(
  currentId: string | undefined | null
): { ids: string[]; index: number } | null {
  if (!currentId) return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredProfileQueue;
    if (!parsed || !Array.isArray(parsed.ids)) return null;
    const idx = parsed.ids.indexOf(currentId);
    if (idx === -1) return null;
    return { ids: parsed.ids, index: idx };
  } catch {
    return null;
  }
}

export function clearProfileQueue() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
